import { Pagination } from '@skf-internal/ui-components-react-legacy';
import { useIntl } from 'react-intl';

interface OffsetLimitPaginationProps {
  totalItems: number;
  limit: number;
  offset: number;
  onPageChange: (newOffset: number, newLimit: number) => void;
}

const OffsetLimitPagination: React.FC<OffsetLimitPaginationProps> = ({ totalItems, limit, offset, onPageChange }) => {
  const intl = useIntl();

  const handlePageChange = (page: number) => {
    const newOffset = (page - 1) * limit;
    onPageChange(newOffset, limit);
  };

  return (
    <Pagination
      feControls={{
        next: {
          'aria-label': intl.formatMessage({ id: 'search.result.next' })
        },
        prev: {
          'aria-label': intl.formatMessage({ id: 'search.result.previous' })
        }
      }}
      feOnPageChange={(page) => handlePageChange(page)}
      feItemsPerPage={limit}
      fePage={Math.floor(offset / limit) + 1}
      feTotal={totalItems}
    />
  );
};

export default OffsetLimitPagination;
